import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = ({ onLoginSuccess }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [isPopupActive, setIsPopupActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  // Show login popup when component mounts
  useEffect(() => {
    // Small delay to ensure animation works properly
    const timer = setTimeout(() => {
      setIsPopupActive(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Simulate network request with a slight delay
    setTimeout(() => {
      // Simple authentication logic
      if (credentials.username === 'admin' && credentials.password === 'admin123') {
        // Authentication successful
        setError('');
        
        // Call the login success handler from App.js
        onLoginSuccess();
        
        // Add a small delay before navigation to see the success state
        setTimeout(() => {
          // Navigate to admin dashboard
          navigate('/admin');
        }, 1000);
      } else {
        setError('Invalid username or password');
        setLoading(false);
      }
    }, 500);
  };
  
  const closeLoginPopup = () => {
    setIsPopupActive(false);
    // Navigate to home page after closing
    setTimeout(() => {
      navigate('/');
    }, 500); // Wait for animation to complete
  };

  return (
    <div className="login-page">
      <div className={`wrapper ${isPopupActive ? 'active-popup' : ''}`}>
        <span className="icon-close" onClick={closeLoginPopup}>
          <ion-icon name="close-outline"></ion-icon>
        </span>

        {/* Login Form */}
        <div className="form-box login">
          <h2>Admin Login</h2>
          {error && (
            <div className="error-message">
              <p>{error}</p>
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="input-box">
              <span className="icon">
                <ion-icon name="person"></ion-icon>
              </span>
              <input
                type="text"
                name="username"
                value={credentials.username}
                onChange={handleChange}
                required
              />
              <label>Username</label>
            </div>
            <div className="input-box">
              <span className="icon">
                <ion-icon name="lock-closed"></ion-icon>
              </span>
              <input
                type="password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                required
              />
              <label>Password</label>
            </div>
            <div className="remember-forgot">
              <label><input type="checkbox" />Remember me</label>
              <a href="#">Forgot Password?</a>
            </div>
            <button type="submit" className="btn" disabled={loading}>
              {loading ? 'Processing...' : 'Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;